export default "__VITE_PUBLIC_ASSET__abf41140__"